import React from 'react';
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { specProgReqActions } from '_actions';

class SpecialProgListItem extends React.Component {
    render() {
        return (
            <div
                className={
                    this.props.id === this.props.selectedMessage ? messageCenterCommonStyles.selected_message :
                        this.props.message.isRead === true ? messageCenterCommonStyles.read_message : messageCenterCommonStyles.unread_message
                }
                onClick={() => this.props.changeMessage(this.props.id)}>
                {this.props.message.ptname}
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        message: state.entities.specProgReqMsgs[ownprops.id],
        selectedMessage: state.ui.specProgReqMsgs.selectedMessage,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        changeMessage: bindActionCreators(specProgReqActions.changeSelection, dispatch)
    };
}

const connectedSpecialProgListItem = connect(mapStateToProps, mapDispatchToProps)(SpecialProgListItem);
export { connectedSpecialProgListItem as SpecialProgListItem };